import React, { useEffect, useState } from "react";
import axios from "axios";
import "./form02.css";
import Logo from "../logo/Manga_Cons _Logo.png";
let student;
const Form02 = ({ setLoading, data }) => {
  const [student, setStudent] = useState(null);

  return (
    <div className="std_scroll">
      <div className="form02 fx-cl space1">
        <div className="Form02Header fx-ac fx-jc space4">
          <figure>
            <img src={Logo} alt="logo" />
          </figure>
          <div className="fx-cl fx-jc">
            <h2>MANGA COLLEGE OF NURSING SCIENCES, ZURU</h2>
            <p>
              P.M.B. 02 Zuru-Kontagora Road Amanawa Area, Zuru, Kebbi State
              -Nigeria
            </p>
            <strong>Office of the Registrar</strong>
          </div>
        </div>
        <h3>Student Particular Form</h3>
        <div style={{ textAlign: "center" }}>
          <h4>PART I</h4>
        </div>
        <div className="fx-jb space3">
          <div className="form02comp g g3 space2">
            <div>
              <strong>Student ID:</strong>{" "}
              <span>
                {data?.admission_number || data?.academicInfo?.admission_number}
              </span>
            </div>
            <div>
              <strong>Full Name:</strong>{" "}
              <span>
                {data?.personalInfo.first_Name +
                  " " +
                  data?.personalInfo.sur_Name +
                  " " +
                  data?.personalInfo.other_Name}
              </span>
            </div>
            <div>
              <strong>Date of Birth:</strong>{" "}
              <span>{data?.personalInfo.Date_of_birth.slice(0, 10)}</span>
            </div>
            <div>
              <strong>Gender:</strong> <span>{data?.personalInfo.gender}</span>
            </div>
            <div>
              <strong>Marital status:</strong>{" "}
              <span>{data?.personalInfo.Marital_status}</span>
            </div>

            <div>
              <strong>Email:</strong> <span>{data?.contactInfo.email}</span>
            </div>
            <div>
              <strong>Phone:</strong>{" "}
              <span>+234{data?.contactInfo.phone_number}</span>
            </div>
          </div>

          <img
            className="form02passport"
            src={data?.personalInfo.passport}
            alt="Student Passport"
          />
        </div>

        <div
          style={{
            borderTop: "1px solid #ccc",
            paddingTop: "1.5rem",
            gridTemplateColumns: "1fr 1fr 1fr",
          }}
          className="form02comp g g3 space2"
        >
          <div>
            <strong>State of Origin:</strong>{" "}
            <span>
              {data?.personalInfo.permanent_home_address.State_of_origin}
            </span>
          </div>
          <div>
            <strong>Local Gov't Area:</strong>{" "}
            <span>
              {data?.personalInfo.permanent_home_address.Local_Govt_Area}
            </span>
          </div>
          <div>
            <strong>Address:</strong>{" "}
            <span>
              {data?.personalInfo.permanent_home_address.line_address}
            </span>
          </div>
          <div>
            <strong>Next of Kin Name:</strong>{" "}
            <span>{data?.contactInfo.next_of_kin.full_name}</span>
          </div>

          <div>
            <strong>Next of Kin address:</strong>{" "}
            <span>{data?.contactInfo.next_of_kin.address}</span>
          </div>
          <div>
            <strong>NOK Phone No.:</strong>{" "}
            <span>{data?.contactInfo.next_of_kin.phone}</span>
          </div>
        </div>
        <div className="form02part">
          <h4>PART II</h4>
        </div>
        <div
          style={{
            borderTop: "1px solid #ccc",
            paddingTop: "1.5rem",
            gridTemplateColumns: "1fr 1fr 1fr",
          }}
          className="form02comp g g3 space2"
        >
          <div>
            <strong>Entry Session:</strong>{" "}
            <span>{data?.academicInfo?.entry_session}</span>
          </div>
          <div>
            <strong>Department:</strong>{" "}
            <span>{data?.academicInfo?.department}</span>
          </div>
          <div>
            <strong>Programme of Study:</strong>{" "}
            <span>{data?.academicInfo?.programme}</span>
          </div>
          <div>
            <strong>Level:</strong>{" "}
            <span>{data?.academicInfo?.state?.level}</span>
          </div>
          <div>
            <strong>Present Session:</strong>{" "}
            <span>{data?.academicInfo?.state?.pressent_session}</span>
          </div>
        </div>
        <div className="fx-jb space4" style={{ marginTop: "5rem" }}>
          <div
            className="fx-cl fx-ac fx-jc space1"
            style={{ width: "22rem", textAlign: "center" }}
          >
            <p
              style={{
                borderTop: "1px solid #666",
                paddingTop: "1rem",
                width: "100%",
              }}
            >
              Student Signature
            </p>
          </div>
          <div
            className="fx-cl fx-ac fx-jc space1"
            style={{ width: "22rem", textAlign: "center" }}
          >
            <p
              style={{
                borderTop: "1px solid #666",
                paddingTop: "1rem",
                width: "100%",
              }}
            >
              Registrar's Signature
            </p>
          </div>
        </div>
        <ul>
          <em>Distribution:</em>
          <li>Head of Department</li>
          <li>Registrar</li>
          <li>Student's Copy</li>
        </ul>
      </div>
    </div>
  );
};

export default Form02;
